<p class="section-description">
  Replica of the application banner's RPO chart with mock data. Toggle a scenario to drive different empty states and
  the chart's auto-escalating preset window logic.
</p>
<div class="chart-scenario-toggle">
  @for (scenario of chartScenarios; track scenario) {
    <button
      type="button"
      class="chart-scenario-btn"
      [class.active]="chartScenario === scenario.key"
      (click)="setChartScenario(scenario.key)"
      [title]="scenario.description"
    >
      {{ scenario.label }}
    </button>
  }
</div>
<div class="chart-preview-host">
  <!-- 460×115 frame matching production. null → loading; [] → "No RPO
    data yet"; length>0 → chart. Never show "No RPO data yet"
    before the fetch confirms an empty array. -->
  <div class="chart-preview-frame">
    @if (chartData !== null) {
      @if (chartData.length > 0) {
        <rpo-chart [rpo]="chartRpoSeconds" [recoveryPointAttempts]="chartData"></rpo-chart>
      } @else {
        <div class="chart-no-data">No RPO data yet</div>
      }
    } @else {
      <div class="chart-loading" role="status" aria-label="Loading RPO chart">
        <div class="chart-skeleton-area"></div>
        <div class="chart-skeleton-threshold"></div>
        <div class="chart-skeleton-pills">
          <div class="chart-skeleton-pill"></div>
          <div class="chart-skeleton-pill"></div>
          <div class="chart-skeleton-pill"></div>
          <div class="chart-skeleton-pill"></div>
        </div>
      </div>
    }
  </div>
</div>
